import request from "@/utils/request";

// 智慧交流
export const bigScreenTalk = (data) =>
  request({
    url: "/bigScreen/intelligentTalk",
    method: "POST",
    data: data,
  });

// 实时播报
export const bigScreenBroadcast = (data) =>
  request({
    url: "/bigScreen/ssbbList",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: data,
  });

// 智慧服务
export const bigScreenService = (data) =>
  request({
    url: "/bigScreen/intelligentService",
    method: "POST",
    data: data,
  });

// 智慧服务点单
export const listByPageBean = (data) =>
  request({
    url: "/serveRequest/listByPageBean",
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    data: data,
  });

// 照护服务明细
export const planRecordBeanList = (data) =>
  request({
    url: "/bizServicePlanRecord/planRecordBeanList",
    method: "POST",
    data: data,
  });

// 智慧安防
export const bigScreenSecurity = (data) =>
  request({
    url: "/bigScreen/intelligentSecurity",
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    data: data,
  });

// 组件调用
export const componentCalls = (data) =>
  request({
    url: "/bigScreen/bigScreeModule",
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    data: data,
  });
